export const customerTypes = {
  CREATE_ORDER_BY_CUSTOMER_START: "CREATE_ORDER_BY_CUSTOMER_START",
  CREATE_ORDER_BY_CUSTOMER_SUCCESS: "CREATE_ORDER_BY_CUSTOMER_SUCCESS",
  CREATE_ORDER_BY_CUSTOMER_FAILED: "CREATE_ORDER_BY_CUSTOMER_FAILED",
  CREATE_ORDER_BY_CUSTOMER_END: "CREATE_ORDER_BY_CUSTOMER_END",

  GET_ALL_CUSTOMER_ORDER_START: "GET_ALL_CUSTOMER_ORDER_START",
  GET_ALL_CUSTOMER_ORDER_SUCCESS: "GET_ALL_CUSTOMER_ORDER_SUCCESS",
  GET_ALL_CUSTOMER_ORDER_FAILED: "GET_ALL_CUSTOMER_ORDER_FAILED",
  GET_ALL_CUSTOMER_ORDER_END: "GET_ALL_CUSTOMER_ORDER_END",

  GET_A_CUSTOMER_ORDER_START: "GET_A_CUSTOMER_ORDER_START",
  GET_A_CUSTOMER_ORDER_SUCCESS: "GET_A_CUSTOMER_ORDER_SUCCESS",
  GET_A_CUSTOMER_ORDER_FAILED: "GET_A_CUSTOMER_ORDER_FAILED",
  GET_A_CUSTOMER_ORDER_END: "GET_A_CUSTOMER_ORDER_END",

  UPDATE_CUSTOMER_ORDER_START: "UPDATE_CUSTOMER_ORDER_START",
  UPDATE_CUSTOMER_ORDER_SUCCESS: "UPDATE_CUSTOMER_ORDER_SUCCESS",
  UPDATE_CUSTOMER_ORDER_FAILED: "UPDATE_CUSTOMER_ORDER_FAILED",
  UPDATE_CUSTOMER_ORDER_END: "UPDATE_CUSTOMER_ORDER_END",

  DELETE_CUSTOMER_ORDER_START: "DELETE_CUSTOMER_ORDER_START",
  DELETE_CUSTOMER_ORDER_SUCCESS: "DELETE_CUSTOMER_ORDER_SUCCESS",
  DELETE_CUSTOMER_ORDER_FAILED: "DELETE_CUSTOMER_ORDER_FAILED",
  DELETE_CUSTOMER_ORDER_END: "DELETE_CUSTOMER_ORDER_END",
};
